import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { tentarRefresh } from '../lib/api';
import { useSessao } from '../lib/sessao';

/**
 * Envolve as rotas autenticadas:
 * 1. ao carregar a página, tenta restaurar a sessão pelo cookie de refresh;
 * 2. sem sessão → /login (guardando de onde veio);
 * 3. com senha provisória (veio de importação) → força /trocar-senha;
 * 4. com TOTP pendente (perfil exige) → força /configurar-2fa antes de qualquer outra tela.
 *
 * A senha vem antes do segundo fator de propósito: enquanto a senha for a que veio na
 * planilha, quem tiver a planilha é aquela pessoa, e configurar o autenticador por cima
 * disso protegeria a conta errada.
 */
export function RotaProtegida() {
  const { accessToken, usuario, restaurando, concluirRestauracao } = useSessao();
  const local = useLocation();

  useEffect(() => {
    if (!restaurando) return;
    if (accessToken) {
      concluirRestauracao();
      return;
    }
    void tentarRefresh().finally(concluirRestauracao);
  }, [restaurando, accessToken, concluirRestauracao]);

  if (restaurando) {
    return <p className="p-8 text-center text-sm text-neutral-500">Carregando…</p>;
  }
  if (!accessToken || !usuario) {
    return <Navigate to="/login" replace state={{ de: local.pathname }} />;
  }
  if (usuario.senhaTemporaria && local.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }
  if (usuario.totpPendente && local.pathname !== '/configurar-2fa') {
    return <Navigate to="/configurar-2fa" replace />;
  }
  return <Outlet />;
}
